import React, { useContext, useEffect, useState } from 'react'
import { IoSearchOutline } from 'react-icons/io5'
import Button from '../../components/Button/Button'
import PartnerCard from '../../components/Cards/PartnerCard'
import axiosInstance from '../../services/api/axiosInstance'
import toast from 'react-hot-toast'
import { IoIosInformationCircleOutline } from 'react-icons/io'
import images from '../../utils/images'
import { useNavigate } from 'react-router-dom'
import PartnerContext from '../../hooks/PartnerContext'
import Joyride, { STATUS } from 'react-joyride';
import Cookie from 'js-cookie'
import Modal from 'react-bootstrap/Modal';


const PartnerHome = () => {
    // partner Context
    const { subscriptionExpiredShow, setPageNumber, setSelectedCard, setHomeApiDataMapping, setPartnerHomeDatas, setImageData
        , setPdfData, setImageBlob, setPdfBlob, setExistingAd, setJobAdStatus, partnerProfileDropdown, partnerPool, setSelectedTemplateCard,
        country

    } = useContext(PartnerContext);
    const pageRender = useNavigate();

    const [temporaryModal, setTemporaryModal] = useState(false);
    const count = ['1', '2', '3', '4', '5', '6']
    const [cardWithCardLoading, setCardWithCardLoading] = useState(true)
    const [twoHundredResponse, setTwoHundredResponse] = useState('')
    const [sortByValue, setSortByValue] = useState('default')
    const [cardStatus, setCardStatus] = useState('opened')
    const [adFeedback, setAdFeedback] = useState("")
    const [receiveReferrals, setReceiveReferrals] = useState("Y")
    const [referralCount, setReferralCount] = useState(0)

    // state for api
    const [partnerCardDetails, setPartnerCardDetails] = useState([]);
    const [partnerCardDetailsDuplicate, setPartnerCardDetailsDuplicate] = useState([]);

    // Extended Validity and Additional Post states
    const [postLeft, setPostLeft] = useState(0);
    const [totalPostLeft, setTotalPostLeft] = useState(0);
    const [costPerAd, setCostPerAd] = useState(0);
    const [costToExtend, setCostToExtend] = useState(0);
    const [refreshState, SetRefreshState] = useState(false)
    const [adCount, setAdCount] = useState("")

    const handlePartnerRadioButton = (e) => {
        setAdFeedback("")
        setReferralCount(0)
        setReceiveReferrals(e.target.value)
    }

    const handleOpenDropDown = (drop) => {
        setCardStatus(drop);
    }

    // Partner Home Open,Close,Pause
    const getPartnerHomePageDetails = async () => {
        setCardWithCardLoading(false)
        const homeParams = {
            "post_status": cardStatus
        }
        try {
            const response = await axiosInstance.post("/get_partner_home_view", homeParams)
            setCardWithCardLoading(true)


            if (response.data.error_code === 0 || response.data.error_code === 200) {
                // joy ride
                if (response.data.error_code === 200) {
                    setTwoHundredResponse('200')
                    Cookie.set("isPartnerFirstVisit", true)
                    Cookie.set("isPartnerPoolFirstVisit", true)
                }
                setPartnerCardDetails(response.data.data[0].post_list)
                setPartnerCardDetailsDuplicate(response.data.data[0].post_list)
                setHomeApiDataMapping(response.data.data[0].post_list)

                setPostLeft(response.data.data[1].posts_left)
                setCostPerAd(response.data.data[2].cost_per_ad)
                setCostToExtend(response.data.data[3].cost_to_extend_ad)
                setTotalPostLeft(response.data.data[4].total_posts)
            }


        }
        catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getPartnerHomePageDetails()
        setSortByValue("default")
    }, [cardStatus, refreshState])

    // Sorting with dateposted, a-z , z-a
    const handleSortByDropDown = (sortValue) => {
        switch (sortValue) {
            case "Date Posted":
                setSortByValue("Date Posted")
                var sorting = partnerCardDetails.sort(function (a, b) {

                    let d1 = new Date(a.posted_on),
                        d2 = new Date(b.posted_on)
                    if (d1 > d2) {
                        return -1;
                    }
                })
                setPartnerCardDetailsDuplicate(sorting)

                break;

            case "A - Z":
                setSortByValue("A - Z")
                var sorting = partnerCardDetails.sort(function (a, b) {
                    if (a.title.toLowerCase() < b.title.toLowerCase()) {
                        return -1;
                    }
                })
                setPartnerCardDetailsDuplicate(sorting)

                break;

            case "Z - A":
                setSortByValue("Z - A")
                var sorting = partnerCardDetails.sort(function (a, b) {
                    if (b.title.toLowerCase() < a.title.toLowerCase()) {
                        return -1;
                    }
                })
                setPartnerCardDetailsDuplicate(sorting)

                break;
            default:
                break;
        }
    }


    // handle Search

    const handleSearchCard = (e) => {
        var searchResults = partnerCardDetails.filter((partner) => {
            return partner.title.toLowerCase().includes(e.target.value.toLowerCase().trim())
        })
        setPartnerCardDetailsDuplicate(searchResults)
    }

    // Post Card Button
    const handlePostCardButton = () => {
        SetRefreshState(!refreshState)
        setPartnerHomeDatas({
            id: "",
            title: "",
            shortDescription: "",
            detailedDescription: "",
            link: "",
            image: "",
            pdf: ""
        })
        setImageData([])
        setPdfData([])
        setImageBlob({})
        setPdfBlob({})
        setPageNumber(true)
        setJobAdStatus("Start with a new Ad post")
        setSelectedCard(false)
        setSelectedTemplateCard(true)
        setExistingAd(false)
        pageRender("/partner_dashboard/cardForm")
    }

    //    Ad Close
    const postPartnerCloseDetails = async (id, adFeedback, cardStatus, count) => {
        var closeJobParams = {
            id: id,
            post_status: cardStatus,
            feedback: adFeedback,
            is_referral_received: receiveReferrals,
            total_referrals_received: count

        }

        try {
            const response = await axiosInstance.post("/close_posted", closeJobParams)
            if (response.data.error_code === 0) {
                document.getElementById(`closeModal-${id}`).click()
                setAdFeedback('')
                setReferralCount(0)
                setReceiveReferrals("Y")
                setTimeout(() => {
                    getPartnerHomePageDetails()
                }, 1000)

            }
        }
        catch (catchError) {
            console.log(catchError)
        }
    }

    // Ad Pause
    const postPartnerPauseDetails = async (id, cardStatus) => {
        var responseCardStatus = cardStatus === 'Paused' ? 'paused' : ''
        const pauseJobParams = {
            id: id,
            post_status: responseCardStatus
        }

        try {

            const response = await axiosInstance.post("/status_update_posted", pauseJobParams)

            if (response.data.error_code === 0) {
                setTimeout(() => {
                    getPartnerHomePageDetails()
                }, 1000)

            }
        }
        catch (catchError) {
            console.log(catchError)
        }
    }

    // Ad Delete
    const postPartnerDelete = async (id) => {
        const deleteJobParams = {
            key_id: id
        }

        try {
            const response = await axiosInstance.post("/delete_learning_post", deleteJobParams)

            if (response.data.error_code === 0) {
                setTimeout(() => {
                    getPartnerHomePageDetails()
                }, 1000)

            }
        }
        catch (catchError) {
            console.log(catchError)
        }
    }

    // Open paused Ad
    const postOpenPausedCard = async (id, cardStatus) => {
        var responseCardStatus = cardStatus === 'Open' ? 'opened' : ''

        const openPausedJobParams = {
            id: id,
            post_status: responseCardStatus,
        }
        try {

            const response = await axiosInstance.post("/status_update_posted", openPausedJobParams)

            if (response.data.error_code === 0) {
                setTimeout(() => {
                    getPartnerHomePageDetails()
                }, 1000)

            }
        }
        catch (catchError) {
            console.log(catchError)
        }
    }

    // Api handling with button click
    const handlePauseModal = (e, id, cardStatus) => {
        postPartnerPauseDetails(id, cardStatus)
    }

    const handleJobDelete = (e, id) => {
        postPartnerDelete(id)
    }

    const handleCloseModal = (e, receiveReferrals, adFeedback, referralCount, id, cardStatus) => {
        var count = (Number(referralCount));
        if (receiveReferrals === "N") {
            if (adFeedback == "") {

                toast("Please fill the fields", {
                    icon: (
                        <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
                    ),
                });
            }
            else {
                postPartnerCloseDetails(id, adFeedback, cardStatus, count)
            }
        }
        else {
            if (count === 0 || count === "" && adFeedback === "") {
                toast("Please fill all the fields", {
                    icon: (
                        <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
                    ),
                });
            }
            else if (adFeedback === "") {
                toast("Please enter the feedback", {
                    icon: (
                        <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
                    ),
                });
            }
            else if (count === 0 || count === "") {
                toast("Please enter the referral count", {
                    icon: (
                        <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
                    ),
                });
            }
            else {
                postPartnerCloseDetails(id, adFeedback, cardStatus, count)
            }
        }
    }



    const handleOpenModal = (e, id, cardStatus) => {
        postOpenPausedCard(id, cardStatus)
    }

    const handleAdFeedback = (e) => {
        setAdFeedback(e.target.value)
    }

    // Additional Ad Post 
    const additionalAdPost = async (e, adCount) => {
        let additionalAdPostParams;

        if (adCount > 0 && adCount !== "") {
            if (country === "India") {

                additionalAdPostParams = {
                    lookup_key: process.env.REACT_APP_INDIAN_PRICE_ADDITIONALADS,
                    no_of_jobs: adCount,
                    is_date_extend: 0,
                    product: "Additional_Ads",
                    job_id: "",
                    user: "Partner"
                }
            }
            else {

                additionalAdPostParams = {
                    lookup_key: process.env.REACT_APP_US_PRICE_ADDITIONALADS,
                    no_of_jobs: adCount,
                    is_date_extend: 0,
                    product: "Additional_Ads",
                    job_id: "",
                    user: "Partner"
                }
            }

            try {

                const response = await axiosInstance.post("/create_payment_session", additionalAdPostParams)

                if (response.data.error_code === 0) {
                    window.location.href = response.data.data.url;
                    setAdCount("")
                    document.getElementById("additionalAdPostCloseButton").click()
                } else {
                    toast.error(response.data.message);
                }
            }
            catch (catchError) {
                console.log(catchError)
            }
        }

        else {
            toast("Please ensure the field is filled out correctly", {
                icon: (
                    <IoIosInformationCircleOutline className="fs-2 brand-color me-1" />
                ),
            });
        }
    }


    // Extend Validity Post 

    const extendValidityPost = async (e, adId, modalCloseId) => {
        let extendValidityPostParams;
        if (country === "India") {
            extendValidityPostParams = {
                lookup_key: process.env.REACT_APP_INDIAN_PRICE_EXTENDADS,
                no_of_jobs: 1,
                is_date_extend: 1,
                product: "Extend_Ads",
                job_id: adId,
                user: "Partner"
            }
        }
        else {

            extendValidityPostParams = {
                lookup_key: process.env.REACT_APP_US_PRICE_EXTENDADS,
                no_of_jobs: 1,
                is_date_extend: 1,
                product: "Extend_Ads",
                job_id: adId,
                user: "Partner"
            }
        }
        try {

            const response = await axiosInstance.post("/create_payment_session", extendValidityPostParams)

            if (response.data.error_code === 0) {
                window.location.href = response.data.data.url;
                document.getElementById(modalCloseId).click()
            } else {
                toast.error(response.data.message);
            }
        }
        catch (catchError) {
            console.log(catchError)
        }
    }


    // JOYRIDE

    const steps = [
        {
            target: 'body',
            content: <div className="text-center">
                <h4 className='fw-bold mb-4'>Welcome to 2nd Careers</h4>
                <p>Create and manage ad postings, and connect with experienced professionals.</p>
            </div>,
            placement: "center"
        },
        {
            target: '#partnerPostAd',
            content: 'Click here to post a new Ad and enhance your visibility among experienced professionals seeking your expertise.',
            placement: "top"
        },
        {
            target: `#${partnerProfileDropdown}`,
            content: 'Manage your company profile and showcase important information about your organization.',
            placement: "top"
        },
        {
            target: `#${partnerPool}`,
            content: 'Explore professionals on the 2nd Careers platform seeking opportunities.',
            placement: "top"
        },
    ];
    const [run, setRun] = useState(false);

    useEffect(() => {
        setRun(true);
        setTemporaryModal(Cookie.get('temporary_modal') ? Cookie.get('temporary_modal') : false)
    }, []);


    const handleJoyrideCallback = (data) => {
        const { status } = data;

        if ([STATUS.SKIPPED, STATUS.FINISHED].includes(status)) {
            Cookie.remove("isPartnerFirstVisit");
        }
    };

    const handlePremiumPlan = () => {
        document.getElementById("additionalAdPostCloseButton").click()
        pageRender("/partner_dashboard/pricing-plan")
    }

    return (
        <>
            <div className="container-fluid community-page-bg p-0">
                <div className="container h-100 employer-home-page pt-4 py-2">
                    <div className="row row-cols-xl-2 row-cols-lg-2 row-cols-md-2
                 align-items-lg-center justify-content-lg-between align-items-md-center justify-content-md-evenly employerHomePadding">
                        <div className="col-xl-5 col-lg-12 col-sm-12 col-md-12 ">


                            <div className="row align-items-lg-center justify-content-lg-between align-items-md-center justify-content-md-between">

                                {cardWithCardLoading ?

                                    <div className='col-lg-7 col-sm-7 col-md-7'>
                                        <div className="dropdown employer-custom-dropdown">
                                            <button
                                                id='partnerSortByButton'
                                                className="btn dropdown-toggle rounded py-2 w-100 buttonMarginBottom"
                                                type="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            ><span className='fw-semibold'>Sort by : </span><span>{sortByValue}</span></button>

                                            <ul className="dropdown-menu employer-custom-dropdown border-0 shadow w-100">

                                                <li><a className="dropdown-item fw-medium  ps-4" onClick={() => handleSortByDropDown('Date Posted')}>Date Posted</a></li>
                                                <hr className='m-0 mx-4 buttonLineColor' />
                                                <li><a className="dropdown-item fw-medium  ps-4" onClick={() => handleSortByDropDown('A - Z')}>A - Z</a></li>
                                                <hr className='m-0 mx-4 buttonLineColor' />
                                                <li><a className="dropdown-item fw-medium  ps-4" onClick={() => handleSortByDropDown('Z - A')}>Z - A</a></li>
                                            </ul>
                                        </div>

                                    </div>
                                    :
                                    <div className='col-lg-7 col-sm-7 col-md-7 ps-4 placeholder-glow'>
                                        <h5 className="card-title">
                                            <span className="placeholder col-9 py-3 rounded-3 buttonMarginBottom"></span>
                                        </h5>
                                    </div>
                                }

                                {cardWithCardLoading ?
                                    <div className=' col-lg-5 col-sm-5 col-md-5'>

                                        <div className="dropdown employer-custom-dropdown">
                                            <button
                                                id='partnerStatusButton'
                                                className="btn dropdown-toggle border-0 w-100 px-2 py-2 buttonMarginBottom .6269+"
                                                type="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            ><span className='fw-semibold'>Status : </span><span>{cardStatus === 'opened' ? 'Open' : cardStatus === 'paused' ? 'Paused' : cardStatus === 'closed' ? 'Closed' : cardStatus}</span></button>

                                            <ul className="dropdown-menu border-0 shadow w-100">
                                                <li><a className="dropdown-item fw-medium ps-4" onClick={() => handleOpenDropDown('opened')}>Open </a></li>
                                                <hr className='m-0 mx-4 buttonLineColor ' />
                                                <li><a className="dropdown-item fw-medium  ps-4" onClick={() => handleOpenDropDown('closed')}>Closed </a></li>
                                                <hr className='m-0 mx-4 buttonLineColor ' />
                                                <li><a className="dropdown-item fw-medium ps-4" onClick={() => handleOpenDropDown('paused')}>Paused </a></li>
                                            </ul>
                                        </div>

                                    </div>
                                    :
                                    <div className='col-lg-5 col-sm-5 col-md-5 placeholder-glow'>
                                        <h5 className="card-title ">
                                            <span className="placeholder col-9 py-3 rounded-3 buttonMarginBottom"></span>
                                        </h5>
                                    </div>
                                }


                            </div>
                        </div>
                        <div className="col-xl-7 col-lg-12 col-md-12 col-sm-12 pt-lg-3 pt-xl-0">
                            {cardWithCardLoading ?
                                <div className="d-lg-flex align-items-lg-center justify-content-lg-between d-md-flex  d-sm-flex align-items-md-center justify-content-md-between
                            justify-content-sm-between align-items-sm-center ">
                                    <div className="position-relative align-items-center searchJobSpace">
                                        <input
                                            id='partnerHomeSearchField'
                                            type="text"
                                            className="form-control shadow rounded px-5 search-field buttonMarginBottom"
                                            placeholder="Search by ad title"
                                            onChange={(e) => handleSearchCard(e)}
                                        />
                                        <span className='fs-5 search-icon'><IoSearchOutline /></span>
                                    </div>
                                    <div className="post p-2">
                                        <span className='additional-post brand-color'>Remaining Posts : {postLeft}/{totalPostLeft}</span>
                                    </div>

                                    <div className='align-items-center' id="partnerPostAd">
                                        {postLeft <= 0 ?
                                            <Button id="postAnAdButton" className='btn btn-brand-color postButton-Size fw-bold buttonMarginBottom ' data_bs_toggle="modal" data_bs_target="#additionalAdPostModal"
                                                title="&#43; Post&nbsp;an&nbsp;ad" />
                                            :
                                            <Button id="postAnAdButton" className='btn btn-brand-color postButton-Size fw-bold buttonMarginBottom ' functionOnchange={handlePostCardButton}
                                                title="&#43; Post&nbsp;an&nbsp;ad" />
                                        }

                                    </div>



                                </div>
                                :

                                <div className='row align-items-lg-center justify-content-lg-between align-items-md-center justify-content-md-between
                            justify-content-sm-between align-items-sm-center placeholder-glow'>
                                    <div className='col-lg-6 col-sm-8 col-md-7'>
                                        <h5 className="card-title ">
                                            <span className="placeholder col-9 py-3 rounded-3 buttonMarginBottom"></span>
                                        </h5>
                                    </div>
                                    <div className='col-lg-4 col-sm-4 col-md-5'>
                                        <h5 className="card-title ">
                                            <span className="placeholder col-9 py-3 rounded-3 buttonMarginBottom"></span>
                                        </h5>
                                    </div>
                                </div>

                            }


                        </div>
                    </div>
                    <hr className='mx-4 mx-sm-5' />


                    <div className="eHome-body-page-height mt-4 overflow-scroll employerHomePadding employerHomeMediumPadding px-0 px-md-5">
                        <div className="col-lg-12">

                            {cardWithCardLoading ?
                                (
                                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 g-3 mb-2">


                                        {
                                            partnerCardDetailsDuplicate.length > 0 ?

                                                partnerCardDetailsDuplicate.map((value, index) => {
                                                    return (
                                                        <div className="col" key={index}>
                                                            <PartnerCard
                                                                cardTitle={value.title}
                                                                cardTitleStyle="learningTitle"
                                                                cardDate={value.posted_on}
                                                                cardShortDescription={value.short_description}
                                                                cardDetailedDesciption={value.detailed_description}
                                                                imageSource={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${value.image}`}
                                                                imageClassName="rounded-3 w-100 img-fluid learning-img-height"
                                                                viewed={value.view_count}
                                                                cardId={value.partner_id}
                                                                id={value.learning_id}
                                                                cardStatus={cardStatus}
                                                                handleOpenModal={handleOpenModal}
                                                                handlePauseModal={handlePauseModal}
                                                                handleCloseModal={handleCloseModal}
                                                                handleJobDelete={handleJobDelete}
                                                                handleAdFeedback={handleAdFeedback}
                                                                adFeedback={adFeedback}
                                                                setAdFeedback={setAdFeedback}


                                                                handlePartnerRadioButton={handlePartnerRadioButton}
                                                                receiveReferrals={receiveReferrals}
                                                                setReceiveReferrals={setReceiveReferrals}
                                                                referralCount={referralCount}
                                                                setReferralCount={setReferralCount}

                                                                costToExtend={costToExtend}
                                                                remainingDays={value.days_left}
                                                                extendValidityPost={extendValidityPost}
                                                            />
                                                        </div>
                                                    )
                                                })

                                                :
                                                <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 h-100'>
                                                    <div className='d-flex justify-content-center h-100'>
                                                        {twoHundredResponse !== '' ?
                                                            <div className="card text-center border-0 rounded-4 py-3">
                                                                <div className="card-body">
                                                                    <h4 className="card-title fw-semibold mb-4">Welcome to 2nd Careers!</h4>
                                                                    <p >Post your first ad now to start connecting with top talent.</p>
                                                                    <p >Please take a moment to complete your organization profile. This will help us tailor our services to your specific needs.</p>
                                                                </div>
                                                            </div>
                                                            :
                                                            <img src={images.noRecordsFound} width={250} height={250} />
                                                        }
                                                    </div>
                                                </div>
                                        }


                                    </div>
                                )

                                :
                                // Placeholder Loading
                                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-3 g-4 mb-4">
                                    {

                                        count.map((c, i) => {
                                            return (
                                                <div className="col-12 col-md-6 col-lg-4" key={i}>
                                                    <div
                                                        className="card border-0 p-0 rounded-3 overflow-hidden placeholder-glow"
                                                        aria-hidden="true"
                                                        key={i}
                                                    >
                                                        <div className="card-body p-0">
                                                            <div className="p-3 py-3">
                                                                <span className="placeholder col-12 py-4 rounded-top"></span>
                                                                <span className="placeholder col-12 py-4"></span>
                                                                <span className="placeholder col-12 py-4 rounded-bottom"></span>

                                                            </div>
                                                            <div className="col-12 px-3">
                                                                <h5 className="card-title ">
                                                                    <span className="placeholder col-9 py-3 rounded-3"></span>
                                                                </h5>
                                                                <p className="card-text">
                                                                    <span className="placeholder col-5 py-2 rounded"></span>
                                                                </p>
                                                            </div>
                                                            <span className="placeholder col-3 ms-3 py-2 rounded"></span>
                                                            <p className="card-text px-3">
                                                                <span className="placeholder col-12 py-2 rounded "></span>
                                                                <span className="placeholder col-12 py-2 rounded"></span>
                                                                <span className="placeholder col-8 py-2 rounded"></span>
                                                            </p>

                                                            <div className="card-footer d-flex justify-content-between">
                                                                <button className="btn btn-outline-secondary placeholder col-5"></button>
                                                                <button className="btn btn-outline-secondary placeholder col-5"></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            )
                                        })

                                    }
                                </div>
                            }

                        </div>
                    </div>

                </div>


                {/* Additional Ad post Modal */}
                <div className="modal fade" id="additionalAdPostModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog  modal-dialog-centered">
                        <div className="modal-content py-2 px-3">
                            <div className="modal-header border-0 bg-transparent">
                                <h1 className="modal-title fs-5 fw-bold" id="staticBackdropLabel">Additional ad post</h1>
                                <button type="button" id='additionalAdPostCloseButton' className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setAdCount("")}></button>
                            </div>

                            <hr className='m-0 mx-3' />

                            <div className="modal-body px-3 pt-4 pb-1 w-100">
                                <div className="col mb-3">Number of additional ads that you wish to post</div>
                                <div className="col">
                                    <input
                                        className='form-control rounded'
                                        type="number"
                                        value={adCount}
                                        onChange={(e) => setAdCount(e.target.value)}
                                    />
                                </div>
                                <p className=' py-2 text-secondary jobPost-FontSize'> Pricing for one ad post : <span className='brand-color'> {country === "India" ? `${process.env.REACT_APP_ADDITIONALAD_RUPEES}` : `$${process.env.REACT_APP_ADDITIONALAD_DOLLARS}`}</span> </p>
                                <div className='jobPost-FontSize text-secondary py-2'><IoIosInformationCircleOutline className='brand-color' /> Enhance your experience by upgrading to our Premium or Platinum plans <a className='icon-link cursorPointer' onClick={handlePremiumPlan}>click here !</a></div>
                            </div>

                            <hr className='m-0 mx-3 text-dark' />

                            <div className="modal-footer border-0 my-3 bg-transparent row align-items-center justify-content-between ">
                                <div className="col-6 m-0">
                                    <button type="button" className="btn w-100 btn-outline-secondary fw-bold" data-bs-dismiss="modal" onClick={() => setAdCount("")}>Cancel</button>
                                </div>
                                <div className="col-6 m-0">
                                    <button type="button" className="btn w-100 btn-brand-color fw-bold" onClick={(e) => additionalAdPost(e, adCount)}>Proceed</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                <Modal
                    show={subscriptionExpiredShow}
                    backdrop="static"
                    keyboard={false}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    contentClassName="rounded-4"
                >
                    <Modal.Body>
                        <div className="py-5 px-2 col-12">
                            <div className="row justify-content-center col-12 text-center">
                                <div className="col-6 text-center">
                                    <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}subscription-expired.png`} alt='subscription expired' with={135} height={135} />
                                </div>

                                <div className="col-12">
                                    <h3 className="py-4">Your current plan has Expired</h3>

                                    <p className="mb-5">To continue utilizing our platform effectively, you'll need to upgrade your plan. Upgrading will give you access to all our features and services without interruption.</p>

                                    <button type="button" className="btn btn-brand-color col-8 py-2" onClick={() => pageRender("/partner_dashboard/upgrade_plan", { replace: true })}>Upgrade now</button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                {
                    cardWithCardLoading && Cookie.get("isPartnerFirstVisit") ?
                        <Joyride
                            callback={handleJoyrideCallback}
                            styles={{
                                options: {
                                    width: '500px',
                                    borderRadius: "60px"
                                },
                                buttonNext: {
                                    background: '#e38212',
                                    outline: 'none'
                                },
                                buttonSkip: {
                                    textDecoration: 'underline'
                                },
                                buttonBack: {
                                    color: '#212529',
                                    backgroundColor: '#fff',
                                    border: " 0px",
                                    borderRadius: "4px",
                                    color: "#000",
                                    cursor: "pointer",
                                    fontSize: "16px",
                                    lineHeight: "1",
                                    padding: "8px",
                                    appearance: "none",
                                    outline: "1px solid grey",
                                }
                            }}
                            scrollOffset={300}
                            continuous
                            disableOverlayClose={true}
                            hideCloseButton
                            showSkipButton
                            showProgress
                            steps={steps}
                            run={run}
                        /> : null
                }
            </div>
        </>
    )
}

export default PartnerHome